import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=dba4cdde&scoped=true&"
import script from "./ErrorIcon.vue?vue&type=script&lang=js&"
export * from "./ErrorIcon.vue?vue&type=script&lang=js&"
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=dba4cdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba4cdde",
  null
  
)

export default component.exports